import { render, staticRenderFns } from "./UserSlash.vue?vue&type=template&id=0ef5c006"
import script from "./UserSlash.vue?vue&type=script&lang=js"
export * from "./UserSlash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports